import React from 'react';
import { Caution, Text, cssVar } from '@cad-arc';
import { Tooltip } from '~/common/components/tooltip';
import { formatEffectiveDates } from '../helpers/format-effective-dates';

export { formatEffectiveDates } from '../helpers/format-effective-dates';

type CautionProps = React.ComponentProps<typeof Caution>;

export interface EnhancedCautionProps {
    label: string;
    dateEffectiveFrom?: string;
    dateEffectiveTo?: string;
    description?: string;
    provenance?: string;
    priority?: CautionProps['priorities'];
    size?: CautionProps['size'];
}

const EM_DASH = '—';
export const DEFAULT_CAUTION_PRIORITY = 4;

function MetadataContent({
    dateEffectiveFrom,
    dateEffectiveTo,
    description,
    provenance,
}: Pick<EnhancedCautionProps, 'dateEffectiveFrom' | 'dateEffectiveTo' | 'description' | 'provenance'>) {
    return (
        <div
            data-testid="ENHANCED_CAUTION_TOOLTIP"
            style={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gap: `${cssVar('arc.space.1')} ${cssVar('arc.space.3')}`,
                padding: cssVar('arc.space.2'),
            }}
        >
            <Text fontSize="sm" color="tertiary">Effective:</Text>
            <Text fontSize="sm">{formatEffectiveDates(dateEffectiveFrom, dateEffectiveTo)}</Text>
            <Text fontSize="sm" color="tertiary">Description:</Text>
            <Text fontSize="sm">{description ?? EM_DASH}</Text>
            <Text fontSize="sm" color="tertiary">Provenance:</Text>
            <Text fontSize="sm">{provenance ?? EM_DASH}</Text>
        </div>
    );
}

export function EnhancedCaution({
    label,
    dateEffectiveFrom,
    dateEffectiveTo,
    description,
    provenance,
    priority = DEFAULT_CAUTION_PRIORITY,
    size = 'sm',
}: EnhancedCautionProps) {
    const hasMetadata = Boolean(dateEffectiveFrom || dateEffectiveTo || description || provenance);

    const pill = (
        <Caution size={size} priority={priority}>
            {label}
        </Caution>
    );

    if (!hasMetadata) {
        return pill;
    }

    return (
        <Tooltip
            overlay={
                <MetadataContent
                    dateEffectiveFrom={dateEffectiveFrom}
                    dateEffectiveTo={dateEffectiveTo}
                    description={description}
                    provenance={provenance}
                />
            }
        >
            {pill}
        </Tooltip>
    );
}
